function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from "react";
import PropTypes from "prop-types";
import GoogleMapReact from "google-map-react";
import supercluster from "points-cluster";
import defaultPropTypes from "../utils/prop-types";
import Location from "../utils/model";
import { UserLocationMarker, SearchLocationMarker, GoogleClusterMarker, GoogleMapMarker } from "./google-map-markers";
import { trackHCLClinicClick } from "../../../../../js/project/tracking-gtm-ga4";
var GoogleMap = /*#__PURE__*/function (_React$Component) {
  function GoogleMap(props) {
    var _this;
    _classCallCheck(this, GoogleMap);
    _this = _callSuper(this, GoogleMap, [props]);
    _this.mapIsReset = false;
    _this.isNewSelectedLocation = false;
    _this.handleMapChange = _this.handleMapChange.bind(_this);
    _this.handleClusterClick = _this.handleClusterClick.bind(_this);
    _this.handleLocationMarkerViewClick = _this.handleLocationMarkerViewClick.bind(_this);
    _this.options = {
      styles: _this.getStylesFromSettings(),
      fullscreenControl: false,
      clickableIcons: false,
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_TOP
      }
    };
    _this.searchLocation = props.searchLocation;
    _this.userLocation = props.userLocation;
    _this.selectedLocation = props.selectedLocation;
    _this.state = {
      center: _this.getDataForInitialMapCenter(),
      zoom: props.settings.ZoomLevel,
      radius: _this.props.settings.ClusterRadius,
      zoomDelay: 1500,
      clusters: [],
      locations: _this.props.locations
    };
    _this.cachedClusterKey = "";
    _this.cachedClusters = undefined;
    return _this;
  }
  _inherits(GoogleMap, _React$Component);
  return _createClass(GoogleMap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      navigator.geolocation.getCurrentPosition(function (position) {
        _this2.setState(_this2.setGeolocationPosition(position), function () {
          setTimeout(function () {
            _this2.setState(_this2.setGeolocationPosition(position));
          }, _this2.state.zoomDelay);
        });
      }, function (error) {
        return console.log(error);
      }, {
        enableHighAccuracy: true
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.locations !== prevProps.locations) {
        var clusters = [];
        if (clusters.length === 0) {
          if (this.props.locations && this.state.zoom && this.state.bounds) {
            clusters = this.getClusters(this.props.locations, this.state.zoom, this.state.bounds, this.props.locationsStateHash);
            this.setState({
              clusters: clusters
            });
          }
        }
      }
    }
  }, {
    key: "setGeolocationPosition",
    value: function setGeolocationPosition(position) {
      return {
        center: {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        },
        zoom: 12
      };
    }
  }, {
    key: "getDataForInitialMapCenter",
    value: function getDataForInitialMapCenter() {
      var userIPLocation = this.props.userLocation;
      var settingsLocation = this.props.settings.Bounds.Centerpoint;
      var initialLatitude = settingsLocation.Latitude !== 0 ? settingsLocation.Latitude : userIPLocation.Latitude;
      var initialLongitude = settingsLocation.Longitude !== 0 ? settingsLocation.Longitude : userIPLocation.Longitude;
      return {
        lat: initialLatitude,
        lng: initialLongitude
      };
    }
  }, {
    key: "getStylesFromSettings",
    value: function getStylesFromSettings() {
      try {
        var cleanedString = this.props.settings.MapConfiguration.replace(/\\r/g, "").replace(/\\t/g, "").replace(/\\n/g, "").replace(/\\/g, "");
        var mapConfiguration = JSON.parse(cleanedString);
        return mapConfiguration.googlemap;
      } catch (e) {
        console.error(e);
      }
      return {};
    }
  }, {
    key: "getClusters",
    value: function getClusters(locations, zoom, bounds, locationHash) {
      // if (
      //   this.cachedClusterKey ===
      //     `${zoom}${JSON.stringify(bounds)}${locationHash}` &&
      //   this.cachedClusters
      // ) {
      //   return this.cachedClusters;
      // }
      // this.cachedClusterKey = `${zoom}${JSON.stringify(bounds)}${locationHash}`;
      if ((bounds === null || bounds === void 0 ? void 0 : bounds.ne.lng) < -180 || (bounds === null || bounds === void 0 ? void 0 : bounds.nw.lng) < -180 || (bounds === null || bounds === void 0 ? void 0 : bounds.se.lng) < -180 || (bounds === null || bounds === void 0 ? void 0 : bounds.sw.lng) < -180) {
        bounds.ne.lng = bounds.ne.lng % 360 + 360;
        bounds.nw.lng = bounds.nw.lng % 360 + 360;
        bounds.se.lng = bounds.se.lng % 360 + 360;
        bounds.sw.lng = bounds.sw.lng % 360 + 360;
      }
      if ((bounds === null || bounds === void 0 ? void 0 : bounds.ne.lng) > 180 || (bounds === null || bounds === void 0 ? void 0 : bounds.nw.lng) > 180 || (bounds === null || bounds === void 0 ? void 0 : bounds.se.lng) > 180 || (bounds === null || bounds === void 0 ? void 0 : bounds.sw.lng) > 180) {
        bounds.ne.lng = bounds.ne.lng % 360 - 360;
        bounds.nw.lng = bounds.nw.lng % 360 - 360;
        bounds.se.lng = bounds.se.lng % 360 - 360;
        bounds.sw.lng = bounds.sw.lng % 360 - 360;
      }
      var clusters = supercluster(locations, {
        minZoom: this.props.settings.MinZoom,
        maxZoom: this.props.settings.MaxZoomLevel,
        radius: this.state.radius
      });
      var modClusters = clusters({
        bounds: bounds,
        zoom: zoom
      });
      return modClusters.map(function (_ref) {
        var wx = _ref.wx,
          wy = _ref.wy,
          numPoints = _ref.numPoints,
          points = _ref.points;
        return {
          lat: wy,
          lng: wx,
          numPoints: numPoints,
          id: "".concat(numPoints, "_").concat(points[0].UniqueId),
          points: points
        };
      });
    }
  }, {
    key: "handleMapChange",
    value: function handleMapChange(map) {
      var _this3 = this;
      var center = map.center,
        zoom = map.zoom,
        bounds = map.bounds;
      this.setState({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
      setTimeout(function () {
        _this3.props.onMapChange({
          center: center
        });
      }, 0);
    }
  }, {
    key: "handleClusterClick",
    value: function handleClusterClick(item, currentZoom) {
      var center = {
        lat: item.lat,
        lng: item.lng
      };
      var zoom = currentZoom < this.props.settings.MaxZoomLevel ? Math.min(this.props.settings.MaxZoomLevel, currentZoom + 2) : this.props.settings.MaxZoomLevel + 1;
      this.props.onMapChange({
        center: center
      });
      this.setState({
        zoom: zoom,
        center: center
      });
    }
  }, {
    key: "handleLocationMarkerViewClick",
    value: function handleLocationMarkerViewClick(locationObj) {
      var _this4 = this;
      this.props.onCloseLocation();
      setTimeout(function () {
        _this4.props.onSelectLocation(locationObj);
      }, 0);
      window.DGS.Event.getInstance().trigger("trackLocationsHighlightFromMap", locationObj.Name, locationObj.PostalCode);
      trackHCLClinicClick("".concat(locationObj.Name, " - ").concat(locationObj.PostalCode), locationObj.UniqueId);
    }
  }, {
    key: "resetMapToSelectedLocation",
    value: function resetMapToSelectedLocation(location, currentZoom) {
      var zoomToDecluster = this.props.settings.MaxZoomLevel + 1;
      var center = {
        lat: location.lat,
        lng: location.lng
      };
      var zoom = 0;
      var bounds = null;
      if (currentZoom < zoomToDecluster) {
        zoom = zoomToDecluster;
      } else {
        zoom = currentZoom;
      }
      this.setState({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
    }
  }, {
    key: "resetMapToSearchedLocation",
    value: function resetMapToSearchedLocation(location) {
      var center = {
        lat: location.lat,
        lng: location.lng
      };
      var zoom = this.props.settings.MaxZoomLevel;
      var bounds = null;
      this.setState({
        center: center,
        zoom: zoom,
        bounds: bounds
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state$clusters,
        _this5 = this;
      var _this$state = this.state,
        center = _this$state.center,
        zoom = _this$state.zoom,
        bounds = _this$state.bounds;
      if (this.searchLocation !== this.props.searchLocation && this.props.searchLocation.Name.length) {
        this.searchLocation = this.props.searchLocation;
        this.resetMapToSearchedLocation(this.props.searchLocation);
      }
      if (this.selectedLocation !== this.props.selectedLocation) {
        this.selectedLocation = this.props.selectedLocation;
        this.resetMapToSelectedLocation(this.props.selectedLocation, zoom);
      }
      var UserLocationMarkerView = this.props.userLocationMarker;
      var LocationMarkerView = this.props.locationMarker;
      var SearchMarkerView = this.props.searchMarker;
      var ClusterMarkerView = this.props.clusterMarker;
      return /*#__PURE__*/React.createElement("div", {
        className: "locations-map ".concat(this.props.layoutType),
        style: {
          minHeight: "50vh"
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, this.props.header), /*#__PURE__*/React.createElement("div", {
        className: "content",
        style: {
          height: "100%",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(GoogleMapReact, {
        bootstrapURLKeys: {
          key: this.props.settings.ApiKey
        },
        zoom: zoom,
        center: center,
        options: this.options,
        onChange: this.handleMapChange
        // yesIWantToUseGoogleMapApiInternals
        // onGoogleApiLoaded={this.mapReference}
      }, /*#__PURE__*/React.createElement(UserLocationMarkerView, _extends({}, this.props.userLocation, {
        lat: this.props.userLocation.lat,
        lng: this.props.userLocation.lng
      })), /*#__PURE__*/React.createElement(SearchMarkerView, _extends({}, this.props.searchLocation, {
        lat: this.props.searchLocation.lat,
        lng: this.props.searchLocation.lng
      })), (_this$state$clusters = this.state.clusters) === null || _this$state$clusters === void 0 ? void 0 : _this$state$clusters.map(function (item) {
        if (item.numPoints === 1) {
          return /*#__PURE__*/React.createElement(LocationMarkerView, {
            lat: item.lat,
            lng: item.lng,
            name: item.points[0].Name,
            key: item.id,
            location: Location.fromObject(item.points[0]),
            onClick: function onClick(e) {
              _this5.handleLocationMarkerViewClick(item.points[0]);
              _this5.props.onOpenLocation(Location.fromObject(item.points[0]), e);
            },
            onTempSelectLocation: _this5.props.onTempSelectLocation,
            selectedClass: item.points[0].UniqueId === _this5.props.selectedLocation.UniqueId || item.points[0].UniqueId === _this5.props.tempSelectedLocation.UniqueId ? "selected" : ""
          });
        }
        return /*#__PURE__*/React.createElement(ClusterMarkerView, {
          key: item.id,
          lat: item.lat,
          lng: item.lng,
          points: item.points,
          onClick: function onClick() {
            return _this5.handleClusterClick(item, zoom);
          }
        });
      }))), /*#__PURE__*/React.createElement("div", {
        className: "footer"
      }, this.props.footer));
    }
  }]);
}(React.Component);
export default GoogleMap;
GoogleMap.propTypes = {
  settings: defaultPropTypes.settings,
  locations: defaultPropTypes.locations,
  selectedLocation: defaultPropTypes.location,
  tempSelectedLocation: defaultPropTypes.location,
  openLocation: defaultPropTypes.location,
  onSelectLocation: defaultPropTypes.func,
  onCloseLocation: defaultPropTypes.func,
  onSearchLocation: defaultPropTypes.func,
  onTempSelectLocation: defaultPropTypes.func,
  onOpenLocation: defaultPropTypes.func.isRequired,
  header: defaultPropTypes.components,
  footer: defaultPropTypes.components,
  layoutType: defaultPropTypes.layoutType,
  searchLocation: defaultPropTypes.location,
  userLocation: defaultPropTypes.location,
  zoom: PropTypes.number,
  userLocationMarker: PropTypes.func,
  clusterMarker: PropTypes.func,
  locationMarker: PropTypes.func,
  searchMarker: PropTypes.func,
  onMapChange: PropTypes.func,
  locationDetailOpen: PropTypes.bool
};
GoogleMap.defaultProps = {
  settings: defaultPropTypes.defaultSettings,
  locations: defaultPropTypes.defaultLocations,
  selectedLocation: defaultPropTypes.defaultLocation(),
  tempSelectedLocation: defaultPropTypes.defaultLocation(),
  openLocation: defaultPropTypes.defaultLocation(),
  onSelectLocation: defaultPropTypes.defaultOnSelectLocation,
  onCloseLocation: defaultPropTypes.defaultOnCloseLocation,
  onSearchLocation: defaultPropTypes.defaultOnSearchLocation,
  onTempSelectLocation: defaultPropTypes.defFunc,
  header: defaultPropTypes.defaultComponents(),
  footer: defaultPropTypes.defaultComponents(),
  searchLocation: defaultPropTypes.defaultSearchLocation,
  userLocation: defaultPropTypes.defaultLocation(),
  zoom: 8,
  layoutType: defaultPropTypes.defaultLayoutType,
  userLocationMarker: UserLocationMarker,
  clusterMarker: GoogleClusterMarker,
  locationMarker: GoogleMapMarker,
  searchMarker: SearchLocationMarker,
  onMapChange: function onMapChange() {},
  locationDetailOpen: false
};